import { fetchWithCsrf } from './csrf';
import { Configuration } from '../swagger/configuration';

/**
 * CSRF対応のAPI設定を作成
 * すべてのAPI呼び出しで自動的にCSRFトークンを付与します
 */
export function createApiConfiguration(): Configuration {
  return new Configuration({
    fetchApi: fetchWithCsrf as any
  });
}

/**
 * 企業ユーザー管理画面用のAPI設定を作成
 * basePathを /api/useradmin に設定します
 */
export function createCompanyUserApiConfiguration(): Configuration {
  return new Configuration({
    basePath: '/api/useradmin',
    fetchApi: fetchWithCsrf as any
  });
}

/**
 * CSRF対応のfetchを提供
 */
export { fetchWithCsrf };
